// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState, useEffect } from "react";
// 重新引入CSS文件，用于自定义Dialog样式
import "./index.css";

export default function CenterPage({ info, closeOrder }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  
  useEffect(() => {
    // 添加加载动画效果
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);
  
  const statusStr = [
    translate(getText("待支付")),
    translate(getText("审核通过")),
    translate(getText("审核拒绝")),
    translate(getText("分配卡号")),
    translate(getText("取消订单")),
    translate(getText("审核中")),
  ];
  const statusStr2 = [
    translate(getText("审核中")),
    translate(getText("审核通过")),
    translate(getText("审核拒绝")),
    translate(getText("分配卡号")),
    translate(getText("审核中")),
  ];
  const bankTypeStr = [
    "Visa, Mastercard and JCB",
    "Revolut",
    "Wise",
    "Bank Card",
    "Remitly"
  ];
  const handleCopy = (value) => {
    if (copy(value)) {
      Toast.show({ content: translate(getText("成功")) });
    }
  };
  
  // 根据状态获取颜色
  const getStatusColor = (status) => {
    if (status === 2) return "text-success"; // 成功状态
    if (status === 3 || status === 5) return "text-danger"; // 拒绝或错误状态
    return "text-primary"; // 默认状态
  };
  
  return (
    <div className={`bg-neutral-900/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-white max-w-md mx-auto w-full my-4 shadow-xl border border-neutral-800/50 transition-all duration-500 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      {/* 状态头部 */}
      <div className="flex flex-col items-center justify-center mb-6 py-4 relative">
        {/* 背景装饰 */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10 overflow-hidden">
          <div className="absolute top-0 left-0 w-24 h-24 bg-gradient-to-r from-primary to-primary-light rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-r from-primary-dark to-primary rounded-full blur-2xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        
        <div className={`relative mb-4 z-10 transition-all duration-700 delay-300 ${loaded ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
          {(info?.status == 1 || info?.status == 4 || info?.status == 6) && (
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 rounded-full animate-pulse"></div>
              <img
                src="/depositDetails/icon_wait.svg"
                alt=""
                className="w-16 h-16 sm:w-20 sm:h-20 relative z-10"
              />
            </div>
          )}
          {info?.status == 2 && (
            <div className="relative">
              <div className="absolute inset-0 bg-success/20 rounded-full animate-pulse"></div>
              <img
                src="/depositDetails/success.svg"
                alt=""
                className="w-16 h-16 sm:w-20 sm:h-20 relative z-10"
              />
            </div>
          )}
          {(info?.status == 3 || info?.status == 5) && (
            <div className="relative">
              <div className="absolute inset-0 bg-danger/20 rounded-full animate-pulse"></div>
              <img
                src="/depositDetails/error.svg"
                alt=""
                className="w-16 h-16 sm:w-20 sm:h-20 relative z-10"
              />
            </div>
          )}
        </div>
        
        {info.type == 1 && (
          <h4 className={`text-xl sm:text-2xl font-medium text-center ${getStatusColor(info?.status)} transition-all duration-700 delay-500 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {statusStr[info?.status - 1]}
          </h4>
        )}
        {info.type == 2 && (
          <h4 className={`text-xl sm:text-2xl font-medium text-center ${getStatusColor(info?.status)} transition-all duration-700 delay-500 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {statusStr2[info?.status - 1]}
          </h4>
        )}
      </div>
      
      {/* 详情内容 */}
      <div className={`bg-neutral-800/80 backdrop-blur-sm rounded-lg shadow-card hover:shadow-xl transition-all duration-500 border border-neutral-700/50 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="divide-y divide-neutral-700/50">
          {/* 订单号 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("訂單號"))}
              </div>
              <div className="flex items-center">
                <span className="text-white mr-2 break-all text-sm sm:text-base font-medium">{info?.orderNo}</span>
                <div className="group relative">
                  <button
                    className="w-8 h-8 flex items-center justify-center bg-neutral-700/50 hover:bg-primary/30 rounded-full transition-colors"
                    onClick={() => handleCopy(info?.orderNo)}
                  >
                    <img
                      src="/depositDetails/icon_copy.svg"
                      alt="复制"
                      className="w-4 h-4 group-hover:scale-110 transition-transform"
                    />
                  </button>
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-neutral-900 text-xs text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-20">
                    {translate(getText("复制"))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* 时间 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("時間"))}
              </div>
              <div>
                <span className="text-white text-sm sm:text-base">{info?.createTime}</span>
              </div>
            </div>
          </div>
          
          {/* 交易金额 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("交易金額"))}
              </div>
              <div>
                <span className="text-primary-light font-medium text-base sm:text-lg bg-primary-dark/30 px-3 py-1.5 rounded-lg shadow-inner shadow-primary/10">{info?.czNum}</span>
              </div>
            </div>
          </div>
          
          {/* 银行卡 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("銀行卡"))}
              </div>
              <div>
                <span className="text-white text-sm sm:text-base bg-neutral-700/30 px-2 py-1 rounded">{bankTypeStr[info?.bankType - 1]}</span>
              </div>
            </div>
          </div>
          
          {/* 银行卡号 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("银行卡号"))}
              </div>
              <div>
                <span className="text-white text-sm sm:text-base font-mono">{info?.twC2cBank?.bankNo}</span>
              </div>
            </div>
          </div>
          
          {/* 收款人姓名 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("收款人姓名"))}
              </div>
              <div>
                <span className="text-white text-sm sm:text-base">{info?.twC2cBank?.name}</span>
              </div>
            </div>
          </div>
          
          {/* 备注信息 */}
          <div className="p-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="text-neutral-400 text-sm font-medium">
                {translate(getText("备注信息"))}
              </div>
              <div>
                <span className="text-white break-all text-sm sm:text-base">{info?.remark}</span>
              </div>
            </div>
          </div>
          
          {/* 取消订单按钮 */}
          {info?.status == 4 && (
            <div className="p-4">
              <Button
                type="primary"
                block
                className="h-12 sm:h-14 bg-gradient-primary hover:bg-gradient-secondary transition-all duration-300 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-0.5 focus:ring-2 focus:ring-primary-light/50 text-base"
                onClick={() => setVisible(true)}
              >
                {translate(getText("取消订单"))}
              </Button>
            </div>
          )}
        </div>
      </div>
      
      {/* 返回区域 - 新增 */}
      <div className={`mt-6 flex justify-center transition-all duration-500 delay-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <button 
          onClick={() => navigate(-1)} 
          className="flex items-center gap-2 text-neutral-400 hover:text-white transition-colors px-4 py-2 bg-neutral-800/30 hover:bg-neutral-700/50 rounded-full"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span>{translate(getText("返回"))}</span>
        </button>
      </div>
      
      {/* 确认弹窗 */}
      <Dialog
        visible={visible}
        title={translate(getText("提示"))}
        confirmButtonText={translate(getText("确认"))}
        cancelButtonText={translate(getText("取消"))}
        showCancelButton
        onConfirm={() => {
          setVisible(false);
          closeOrder();
        }}
        onCancel={() => setVisible(false)}
        className="custom-dialog"
      >
        <div className="py-4 px-2 text-center text-black">
          {translate(getText("是否确认取消订单"))}？
        </div>
      </Dialog>
    </div>
  );
}
